<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div><h2>Nekobox Android客户端使用教程</h2>
              <p><strong>关于耗电</strong></p>
              <p>代理软件会接管几乎全局网络通信，所以所有网络方面的电量消耗都会被算在代理软件上，实际上代理软件的运行功耗很少，使用中也不会感到软件对电量有明显影响。</p>
              <h2>一.下载最新版(1.2.9, 2023年11月2日更新)</h2>
              <ul>
                <li>
                  <a href="https://www.91freedom.live/img/client/android/nekobox/NB4A-1.2.9-arm64-v8a.apk">点我下载</a>
                </li>
                <li><a href="https://ghproxy.com/https://github.com/MatsuriDayo/NekoBoxForAndroid/releases/download/1.2.9/NB4A-1.2.9-arm64-v8a.apk">备用下载1</a></li>
                <li><a href="https://github.com/MatsuriDayo/NekoBoxForAndroid/releases/download/1.2.9/NB4A-1.2.9-arm64-v8a.apk">备用下载2</a></li>
                <li><a href="https://wwst.lanzout.com/ioeoM1dobb4f">备用下载(蓝奏云)</a>密码: 6dnk</li>
              </ul>
              <hr>
              <p><strong>注意，请随时保持客户端更新到最新，老版本客户端可能有未修复的漏洞，导致信息泄露，IP被封等情况。</strong></p>
              <div class="display-4 mt-4 mb-4">订阅信息</div>
              <div v-if="accounts.length">
                <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                  <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                  <!-- <a
                    :href="`clash://install-config?url=${subLinks_1}/v1/api/clash/${account.subscription || account._id }?flag=clashmeta&?name=${account.product.title}`"
                    class="btn btn-primary btn-sm mb-2"><i class="fa fa-share"/>点我导入到 Clash Meta</a
                    > -->
                  <!-- <code>{{ `${subLinks_1}/v1/api/clash/${account.subscription || account._id }` }}</code> -->
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/clash/${account.subscription || account._id }?name=${account.product.title}`, $event)" >复制订阅地址1</base-button>
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/clash/${account.subscription || account._id }?name=${account.product.title}`, $event)" >复制订阅地址2</base-button>
                </div>
                <!-- 例子 v2rayng://install-config?url=http%3A%2F%2Fexample.com&name=example
  v2rayng://install-config?url 是固定，url=后面是订阅地址 -->
              </div>
              <h2>二.使用教程</h2>
              <h5>1.确保手机中已下载安装Nekobox。</h5>
              <h5>2.👆上面订阅信息中 点击“复制订阅地址“</h5>
              <!-- <p><a class="btn btn-hero-primary" href="javascript:void()" onclick="copy('https://ki78adcs.doggygo.top:8443/api/v1/client/4c38e9afe24e1a2213477f5bd2f06369?flag=clashmeta')"><i class="fa fa-share "/>点我复制订阅链接</a></p> -->
              <h5>3.打开Nekobox点左上角打开菜单；选择分组，导入配置；在分组下点右上角添加配置：</h5>
              <p><img src="/img/client/android/nekobox/n1.webp" width="350"></p>
              <p><img src="/img/client/android/nekobox/n2.webp" width="350"></p>
              <p><img src="/img/client/android/nekobox/n3.webp" width="350"></p>
              <h5>4.按下图设置好：</h5>
              <!-- <p><a class="btn btn-hero-primary" href="javascript:void()" onclick="copy('https://ki78adcs.doggygo.top:8443/api/v1/client/4c38e9afe24e1a2213477f5bd2f06369?flag=clashmeta')"><i class="fa fa-share "/>点我复制订阅链接</a></p> -->
              <img src="/img/client/android/nekobox/n4.webp" width="350">
              <hr>
              <h5>5.路由设置中打开“禁用Quic“：</h5>
              <img src="/img/client/android/nekobox/n5.webp" width="350">
              <hr>
              <h5>6.返回主界面启动，开始使用：</h5>
              <img src="/img/client/android/nekobox/n6.webp" width="350">
            </div>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }
}
</script>
<style scoped>
.product-title {
  width: 120px;
  display: inline-block;
}
/* .sub-item{

} */
.search-noresults img {
  max-width: 100%;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 400px;
  }
}
</style>
